import { useCountries } from 'api/requests/country';

export const useViewDialogWithdrawalAccount = () => {
  const { countries, loading: countriesLoading } = useCountries();

  return {
    countries: countries ?? [],
    countriesLoading,
  };
};
